import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EnvService } from '../../shared/environment-service/env.service';
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  key: string = "Prov!der@E$k@";
  private _key = CryptoJS.enc.Utf8.parse('1203199320052021');
  private _iv = CryptoJS.enc.Utf8.parse('1203199320052021');

  encryptionEnabled: any;
  constructor(public env: EnvService) {
 this.encryptionEnabled = this.env.Keys.localStorageEncryptionEnabled ? this.env.Keys.localStorageEncryptionEnabled : false;

}


  public SetItem(key: string, value: any) {
    if (this.encryptionEnabled == true || this.encryptionEnabled == 'true')
    {
      if (value && typeof value !== 'string')
        localStorage.setItem(key, this.Ecrypt(value.toString()));
      else
        localStorage.setItem(key, this.Ecrypt(value));
    }
    else {
      localStorage.setItem(key, value);
    }
  }

  public GetItem(key: string): any { 
    let data: any = null;
    if (this.encryptionEnabled == true || this.encryptionEnabled == 'true') {
      data = localStorage.getItem(key) || null;
      return data ? this.Decrypt(data) : data;
    }
    else {
      data = localStorage.getItem(key) || null;
      return data
    }

  }

  public RemoveItem(key: string) {
    localStorage.removeItem(key);
  }

  public Clear() {
    localStorage.clear();
  }

  /** Method to Ecrypt / Decrypt */
  public Ecrypt(text: string): string {
    if (text)
      return CryptoJS.AES.encrypt(text, this.key).toString();
  }

  public Decrypt(text: string): string {
    if (text)
      return CryptoJS.AES.decrypt(text, this.key).toString(CryptoJS.enc.Utf8);
  }

  encryptUsingAES256(text): any {
    if (text) {
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), this._key, {
        keySize: 128 / 8,
        iv: this._iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }

  }
}
